import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useToast } from '../../context/ToastContext';
import Header from '../../components/common/Header';
import Sidebar from '../../components/common/Sidebar';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { FolderGit2, ArrowRight, ShieldCheck, FileCode } from 'lucide-react';
import './MyProjects.css';

const MyProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const { addToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const res = await api.get('/projects/');
      const list = res.data.results || res.data;
      setProjects(list);
    } catch (err) {
      console.error(err);
      addToast('Failed to load assigned projects.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-layout-root">
      <Header />
      <div className="page-body-wrapper">
        <Sidebar />
        <main className="page-main-content" style={{ maxWidth: '1100px' }}>
          
          <div className="projects-header-box">
            <h1 className="projects-title">My Assigned Projects</h1>
            <p className="projects-subtitle">
              Explore your assigned repositories, development workflows, and dedicated AI project mentor.
            </p>
          </div>

          {loading ? <LoadingSpinner label="Loading assigned projects..." /> : (
            projects.length === 0 ? (
              <div className="card projects-empty-card">
                <FolderGit2 size={40} className="projects-empty-icon" />
                <h3>No projects assigned to your account yet.</h3>
                <p style={{ marginTop: '6px' }}>Your Super Admin will assign project repositories shortly.</p>
              </div>
            ) : (
              <div className="projects-grid">
                {projects.map((proj) => (
                  <div key={proj.id} className="card projects-card">
                    
                    {/* Project Header Banner */}
                    <div className="projects-card-banner">
                      <div className="projects-card-banner-top">
                        <span className="badge badge-success" style={{ background: '#ecfdf5', color: '#059669' }}>
                          <ShieldCheck size={10} /> Active Assignment
                        </span>
                        <FileCode size={24} style={{ color: '#06b6d4' }} />
                      </div>
                      <h3 className="projects-card-title">{proj.name}</h3>
                    </div>

                    {/* Card Content */}
                    <div className="projects-card-body">
                      <div>
                        <p className="projects-card-desc">
                          {proj.short_description}
                        </p>
                      </div>

                      <button
                        className="btn btn-primary projects-card-btn"
                        onClick={() => navigate(`/my-projects/${proj.id}`)}
                      >
                        <span>Open Project Details & AI</span>
                        <ArrowRight size={16} />
                      </button>
                    </div>

                  </div>
                ))}
              </div>
            )
          )}

        </main>
      </div>
    </div>
  );
};

export default MyProjects;
